var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAp4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 64,
    viewBox: "0 0 69 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1926 0L0 18.1926V45.1361L18.1926 63.3287H49.9721L68.1647 45.1361V18.1926L49.9721 0H18.1926Z",
    fill: "#424559"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 4.14551L4.14505 20.155V43.8653L20.125 59.8748H48.0395L64.0195 43.8653V20.155L48.0395 4.14551H20.125Z",
    fill: "#121425",
    stroke: "#FFFFF8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1645 20.6H26.1325L34.3245 43H29.9085L28.0845 38.04H20.2125L18.3885 43H13.9725L22.1645 20.6ZM27.1245 34.456L24.1485 25.944H24.0845L21.2045 34.456H27.1245ZM36.58 20.6H50.628L54.052 24.056V31.896L50.596 35.384H40.932V43H36.58V20.6ZM48.644 31.736L49.764 30.616V25.368L48.644 24.248H40.932V31.736H48.644Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAp4);
export default __webpack_public_path__ + "static/media/AP4.5c997a64.svg";
export { ForwardRef as ReactComponent };